<template>
    <div v-resize="onResize">
        <p-order-editor
            v-if    = "selected"
            v-model = "edit"
            :order  = "selected"
            @stored = "onRefresh"
        />

        <v-expansion-panels accordion flat class="mb-1" v-model="expandFilter" style="background-color: transparent" :readonly="prioritize">
            <v-expansion-panel class="pa-0" :key="1" style="background-color: transparent">
                <v-expansion-panel-header :ripple="false" expand-icon="" class="pa-0" style="background-color: white">
                    <c-column-header
                        label = "Aufträge"
                        class="primary mt-2"
                        style  = "font-size: 16px; max-width: calc(100% - 16px)"
                    >
                        <template v-slot:post>
                            <c-toolbar-button
                                v-if     = "isDisponent"
                                class    = "ml-1"
                                style    = "margin-top: -2px;"
                                :icon    = "prioritize ? 'mdi-stop-circle-outline' : 'mdi-drag'"
                                size     = "24"
                                color    = "white"
                                :tooltip = "prioritize ? $t('disposition.order.prioritize.off') : $t('disposition.order.prioritize.on')"
                                @click   = "onPrioritize"
                            />
                        </template>
                        <template v-slot:toolbar>
                            <c-toolbar-button
                                v-if     = "!prioritize"
                                class    = "mr-3"
                                style    = "margin-top: -2px;"
                                :icon    = "compact ? 'mdi-arrow-collapse-vertical' : 'mdi-arrow-expand-vertical'"
                                size     = "22"
                                color    = "white"
                                :tooltip = "compact ? $t('disposition.order.scope.show') : $t('disposition.order.scope.hide')"
                                @click   = "onCompact"
                            />

                            <c-toolbar-button
                                v-if     = "!prioritize && isDisponent"
                                class    = "mr-3"
                                style    = "margin-top: -2px;"
                                icon     = "mdi-plus"
                                size     = "22"
                                color    = "white"
                                :tooltip = "$t('disposition.order.create')"
                                @click   = "onNewOrder"
                            />

                            <c-toolbar-button
                                v-if     = "!prioritize"
                                class    = "mr-3"
                                style    = "margin-top: -2px;"
                                icon     = "mdi-refresh"
                                size     = "22"
                                color    = "white"
                                :tooltip = "$t('disposition.order.refresh')"
                                @click   = "onRefresh"
                            />
                        </template>

                        <template v-slot:filter>
                            <div class="v-flex" v-if="!prioritize" style="margin-top: -2px">
                                <c-item-count :count="count" :key="count" style="padding-top: 1px;" />
                                <a @click.stop="onFilter" >
                                    <v-icon size="18" class="pr-1 white--text">mdi-filter</v-icon>
                                </a>
                                <a @click.stop="onRemoveFilter"  v-if="searchtext">
                                    <v-icon size="18" class="pr-1 white--text ">mdi-filter-off-outline</v-icon>
                                </a>
                            </div>
                        </template>
                    </c-column-header>
                </v-expansion-panel-header>

                <v-expansion-panel-content
                    class = "pa-0 ma-0"
                    style = "padding-right: 10px!important;"
                    eager
                >
                    <div class="lm-border mt-1  mb-1 pa-3 pt-0 " >
                        <div class="pb-1">
                            <v-text-field
                                v-model        = "searchtext"
                                autocomplete   = "off"
                                autocorrect    = "off"
                                autocapitalize = "off"
                                spellcheck     = "false"
                                append-icon    = "fas fa-search"
                                :clearable     = "true"
                                @input         = "onSearch"
                                hide-details
                            />
                        </div>

                        <div class="mb-3">
                            <v-switch
                                :label   = "$t('disposition.order.filter.closed')"
                                v-model  = "filter.showAllOrders"
                                @change  = "onFilter"
                                :ripple  = "false"
                                hide-details
                            />
                        </div>
                    </div>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>

        <draggable
            :disabled   = "!prioritize"
            :list       = "orders.display"
            style       = "overflow-y: scroll; margin-right: 4px;"
            :style      = "'max-height:' + scrollHeight + 'px'"
            ghost-class = "ghost"
        >
            <p-order-card
                v-for       = "(item, index) in orders.display"
                :order      = "item"
                :compact    = "compact"
                :prioritize = "prioritize"
                :background = "background(selected, item)"
                @selected   = "onSelected"
                @edit       = "onEdit"
                @remove     = "onRemove"
                :key        = "index"
                class       = "mb-1 mr-1"
                ref         = "order"
            />
        </draggable>
    </div>
</template>

<script>

import POrderCard from "@/modules/dis/components/order/overview/private/POrderCard.vue";
import POrderEditor from "@/modules/dis/components/order/overview/private/POrderEditor.vue";
import Disposition from "@/modules/dis/service/Disposition";
import Core from "@/modules/core/service/Core";
import draggable from "vuedraggable";
import CColumnHeader from "@/modules/core/components/utils/CColumnHeader.vue";
import CItemCount from "@/modules/core/components/utils/CItemCount.vue";
import CToolbarButton from "@/modules/core/components/utils/CToolbarButton.vue";
import DispositionSecurityMixin from "@/modules/dis/mixins/DispositionSecurityMixin";

export default {
    name: "POrderCardIterator",

    components: {
        CToolbarButton,
        CItemCount,
        CColumnHeader,
        POrderEditor,
      //  CToolbarButton,
        POrderCard,
       // CCardIterator,
        draggable
    },

    props: {

    },

    mixins: [
        DispositionSecurityMixin
    ],

    data: () => ({
        filterHeight: 130,
        topSpace: 120,
        orders: {
            list   : [],
            display: []
        },
        compact: true,
        prioritize: false,
        selected: null,
        edit: false,
        searchtext: "",
        scrollHeight: null,
        count: null,
        expandFilter: false,
        filter: {
            showAllOrders: false
        }
    }),

    created: function () {
        this.$bus.$on(this.$events.dis.assignments, this.onAssignments)
    },

    mounted() {
        this.onRefresh();
    },

    beforeDestroy() {
        this.$bus.$off(this.$events.dis.assignments, this.onAssignments)
    },

    watch: {
        expandFilter () {
            this.$nextTick(() => {
                this.onResize();
            })
        }
    },

    methods: {
        onNewOrder () {
            this.selected = {
                id      : null,
                status  : {
                    id: 1,
                },
                no      : null,
                customer: null,
                company : {
                    id: null,
                },
                scope: {
                    elevator : true,
                    sticker  : true,
                    lgs      : true,
                    condition: true,
                    audit    : true,
                    esg      : true,
                }
            }

            this.edit = true;
        },

        onFilter () {
            this.onRefresh();
        },

        onRemoveFilter () {

        },

        onEdit (order) {
            this.selected = order;
            this.edit = true;
        },

        onCompact () {
            this.compact = !this.compact;
        },

        onPrioritize () {
            this.prioritize = !this.prioritize;
            if (this.prioritize) {
                this.searchtext = null;
                this.filter.showAllOrders = false;
                this.expandFilter = false;
                this.orders.list.sort((l,r) => l.position - r.position)
                this.onSearch();
            } else {
                Disposition.order.updateOrderPosition(this.orders.display).then(() => {
                    Core.message.alert.save(this);
                    this.orders.list.sort((l,r) => l.position - r.position)
                });
            }
        },

        onRemove (order) {
            const query = this.$t("disposition.order.remove.query");
            const text = this.$t("disposition.order.remove.text");

            Core.message.confirm(this, query, text, Core.message.Default, (confirmed) => {
                if (confirmed) {
                    Disposition.order.delete(order).then(() => {
                        Core.message.hint(this, this.$t("order.remove.done"));
                        this.$nextTick(() => {
                            const listIndex = this.orders.list.findIndex (o => o.id === order.id);
                            if (listIndex < 0) {
                                return;
                            }

                            this.orders.list.splice(listIndex, 1);

                            const displayIndex = this.orders.display.findIndex (o => o.id === order.id);
                            if (displayIndex < 0) {
                                return;
                            }

                            this.orders.display.splice(displayIndex, 1);
                        });
                    });
                }
            });
        },

        onSelected (selected) {
            if (this.selected === selected) {
                this.selected = {
                    customer: null,
                }
            } else {
                this.selected = selected;
            }

            this.$emit("selected", this.selected)
        },

        onRefresh () {
            Disposition.order.findAll(this.filter).then (data => {
                this.orders.list = data;
                this.onSearch()
            });
        },

        onAssignments (event) {
            const index = this.orders.list.findIndex (order => order.id === event.order.id);
            if (index >= 0) {
                const order = Core.data.clone(this.orders.list[index]);
                order.assignments = event.assignments;
                this.orders.list[index] = order;
            }

            const displayIndex = this.orders.display.findIndex (order => order.id === event.order.id);
            if (displayIndex >= 0) {
                const order = Core.data.clone(this.orders.display[displayIndex]);
                order.assignments = event.assignments;
                this.orders.display[displayIndex] = order;
                this.$refs.order.forEach(d => {
                    d.onRefresh(order);
                })
            }
        },

        onResize () {
            this.scrollHeight = window.innerHeight - this.topSpace;
            if (this.expandFilter === 0) {
                this.scrollHeight = this.scrollHeight - this.filterHeight;
            }
        },

        onSearch () {
            const orders = [];
            this.orders.list.forEach(order => {
                if (this.match(order, this.searchtext)) {
                    orders.push(order);
                }
            });

            this.count = orders.length;
            this.orders.display = orders;
        },

        background (selected, item) {
            if (selected && selected.id === item.id) {
                return "background-aliceblue"
            }

            return null;
        },



        match (item, text) {
            if (!text) {
                return true;
            }

            const upperCaseText = text.toUpperCase();
            return this.matchProperty(item.no, upperCaseText)
                || this.matchProperty(item.customer.name, upperCaseText)
                ;
        },

        matchProperty (property, text) {
            if (!property) {
                return null;
            }

            return property.toUpperCase().includes (text);
        },
    }
}
</script>

<style scoped>

::v-deep .v-expansion-panel-content__wrap {
    margin: 0;
    padding: 0;
}

::v-deep .v-expansion-panel-header {
    min-height: 10px!important;
}

::v-deep .v-expansion-panel-header__icon {
    display: none;
}

::v-deep .v-expansion-panel-header:not(.v-expansion-panel-header--mousedown):focus:before {
    opacity: 0;
}

.ghost {
    opacity: 0.5;
    background: #c8ebfb;
}

.handle {
    float: left;
    padding-top: 8px;
    padding-bottom: 8px;
}

</style>